export default "__VITE_ASSET__CNGk6ye7__"